
angular.module('bmsApp.settings').factory('UserManagementSvc', function ($http, $log, $window, $q, CRUDSvc, USER_API) {

	return {
		index: function(params){return CRUDSvc.get(USER_API.INDEX, params);},
		create: function (data) {return CRUDSvc.create(USER_API.CREATE, data);},
		read: function (data) {return CRUDSvc.read(USER_API.READ, data);},
		update: function (data) {return CRUDSvc.post(USER_API.UPDATE + '/' + data.id, data);},
		resetAppPin: function (data) {return CRUDSvc.post(USER_API.RESET_APP_PIN, data);},
		resendActivationEmail: function (data) {return CRUDSvc.post(USER_API.RESEND_ACTIVATION_EMAIL + '/' + data.id, data);},
		createFromEmployees: function (data) {return CRUDSvc.post(USER_API.CREATE_FROM_EMPLOYEES, data);},
		delete: function(params) {return CRUDSvc.delete(USER_API.DELETE, params);},
	}

}).constant('USER_API', {
	INDEX: 'api/user/index',
	CREATE: 'api/user/create',
	READ: 'api/user/read',
	UPDATE: 'api/user/update',
	RESEND_ACTIVATION_EMAIL: 'api/user/resend-activation-email',
	CREATE_FROM_EMPLOYEES: 'api/user/create-from-employees',
	DELETE: 'api/user/delete',
	RESET_APP_PIN: 'api/user/reset-app-pin'
});





